/**
 * Firebase Initialization
 * Central export for Firebase services - Americano mode
 */
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import firebaseConfig from './config';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Collection names
export const COLLECTIONS = {
  TOURNAMENTS: 'americano'
};

export default app;
